export default "__VITE_ASSET__BjBZOqsa__"